<template>
  <div>
    <form class="needs-validation" @submit.prevent="submitCreateUnitModel">

      <div class="form-group">
        <p>Тип: {{modelData.type}}</p>
      </div>

      <div class="form-group">
        <label for="with_nds">Код модели:</label>
        <input
            id="with_nds"
            v-model="modelData.code"
            type="text"
            class="form-control form-control-sm"
        />
      </div>

      <div class="form-group">
        <label for="with_nds">Название:</label>
        <input
            id="with_nds"
            v-model="modelData.name"
            type="text"
            class="form-control form-control-sm"
        />
      </div>

      <div class="form-group">
        <label for="with_nds">Примечания:</label>
        <input
            id="with_nds"
            v-model="modelData.description"
            type="text"
            class="form-control form-control-sm"
        />
      </div>

    </form>
  </div>

</template>

<script>

import {integer, email, maxLength, maxValue, minLength, minValue, required} from "vuelidate/lib/validators";

import axios from "axios";

export default {
  // mixins: [validationMixin],
  name: "CreateUnitModel",
  data() {
    return {
      modelData: {
        type: null,
        code: null,
        name: null,
        description: null
      },
      submitted: false,
    }
  },
  mounted() {
  },
  props: {
  },
  watch: {
  },
  computed: {

  },
  validations: {
    modelData: {
    },
  },
  methods: {
    submitCreateUnitModel() {
      // this.submitted = true;
      // // stop here if form is invalid
      // this.$v.modelData.$touch();
      // if (!this.$v.modelData.$invalid) {
      //   this.$emit('submitCreateUnitModel', this.packageData);
      // }
    },
    createNewUnitModel() {
      let formData = new FormData();
      formData.append('type', this.modelData.type);
      formData.append('code', this.modelData.code);
      formData.append('name', this.modelData.name);
      formData.append('description', this.modelData.description);

      axios
          .post(`/v1/unit-models/add`, formData)
          .then(resp => {
            this.$emit('new-unit-model-created', resp.data);
          })
          .catch(err => {
            this.$store.dispatch("addNotification", {
              text: err.response.data.message,
              time: 6,
              color: "danger"
            });
          })
      ;
    }
  },
  created() {

  }
};
</script>

<style scoped lang="css">

</style>
